// NatPat Chemical-Free Defense - Vanilla JS
// Handles: smooth scroll, sticky bottom bar

// ── Smooth scroll for #hash links ──────────────────────────────────────────
document.addEventListener('click', function (e) {
  const a = e.target.closest('a[href^="#"]');
  if (!a) return;
  const hash = a.getAttribute('href');
  if (hash === '#' || hash === '') {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }
  const target = document.querySelector(hash);
  if (target) {
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});

// ── Sticky bottom CTA bar ───────────────────────────────────────────────────
(function () {
  const bar = document.getElementById('sticky-bar');
  if (!bar) return;
  let visible = false;
  function onScroll() {
    const shouldShow = window.scrollY > 300;
    if (shouldShow !== visible) {
      visible = shouldShow;
      bar.classList.toggle('sticky-bar--visible', visible);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
